import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 定义状态
    ej_course_type: "", //课程类型
    ej_course_major: "", //专业目录
    ej_order_type: "", //订单类型
    ej_order_state: "", //支付状态
    count: 0,
  },
  mutations: {
    // 定义改变状态的方法
    COURSE_TYPE(state,list) {
      state.ej_course_type = list
    },

  },
  actions: {
    // 定义异步操作的方法
    incrementAsync({ commit }) {
      setTimeout(() => {
        commit("increment");
      }, 1000);
    },
  },
  getters: {
    // 定义获取状态的方法
    getCourseType: (state) => {
      return state.ej_course_type ;
    },
  },
});
